<!-- -------------------------- Warning Banner -------------------------- -->
@if (showWarning) {
  <div class="status-banner warning">
    <div class="banner-content">
      <div class="banner-icon">
        <g99-icon-btn
          [icon]="warningIcon"
          [height]="20"
          [width]="20"
          [color]="'#ef4444'"
          [strokeColor]="'#fff'"
        />
      </div>
      <div class="banner-text">
        <div class="banner-title">Size limit exceeded</div>
        <div class="banner-message">{{ warningMessage }}</div>
        <div class="banner-stats">
          {{ formatFileSize(totalSize) }} of
          {{ formatFileSize((maxTotalSizeMB ?? 0) * 1024 * 1024) }} used
        </div>

        <div class="banner-progress">
          <div class="progress-bar">
            <div
              class="progress-fill warning"
              [ngStyle]="{ width: progressPercentage + '%' }"
            ></div>
          </div>
          <div class="progress-text warning"> {{ progressPercentage }}% </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- -------------------------- Success Banner -------------------------- -->
@if (showSuccess) {
  <div class="status-banner success">
    <div class="banner-content">
      <div class="banner-icon">
        <g99-icon-btn
          [icon]="tickIcon"
          [height]="20"
          [width]="20"
          [color]="'#28a745'"
          [strokeColor]="'#fff'"
        />
      </div>
      <div class="banner-text">
        <div class="banner-title">Ready to upload</div>
        <div class="banner-message">{{ successMessage }}</div>
        <div class="banner-stats">
          {{ formatFileSize(totalSize) }} of
          {{ formatFileSize((maxTotalSizeMB ?? 0) * 1024 * 1024) }} used
        </div>

        <div class="banner-progress">
          <div class="progress-bar">
            <div
              class="progress-fill success"
              [ngStyle]="{ width: progressPercentage + '%' }"
            ></div>
          </div>
          <div class="progress-text success"> {{ progressPercentage }}% </div>
        </div>
      </div>
    </div>
  </div>
}
